import React from 'react';

const MeleyFlag = () => {
  return (
    <div className="card">
      {/* Product image */}
      <img className="card-img-top" src="../assets/img/flag001.png" alt="Meley Flag" />
      {/* Product details */}
      <div className="card-body p-4">
        <div className="text-center">
          {/* Product name */}
          <h5 className="fw-bolder">Meley Flag</h5>
          {/* Product price */}
          $25.00
        </div>
      </div>
      {/* Product actions */}
      <div className="card-footer p-4 pt-0 border-top-0 bg-transparent">
        <div className="text-center">
          <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_self">
            <input type="hidden" name="shopping_url" value="https://felsiselam.org/shop" />
            <input type="hidden" name="cmd" value="_s-xclick" />
            <input type="hidden" name="hosted_button_id" value="57RCXPKF5J8DL" />
            <input type="hidden" name="currency_code" value="USD" />
            <input
              type="image"
              src="https://www.paypalobjects.com/en_US/i/btn/btn_cart_LG.gif"
              name="submit"
              title="PayPal - The safer, easier way to pay online!"
              alt="Add to Cart"
            />
          </form>
          <span>Or</span><br />
          <a href="#" data-bs-toggle="modal" data-bs-target="#zelle-info-modal-meley">
            <img src="assets/img/Zelle-logo.png" alt="Zelle" width="75" height="35" />
          </a>
        </div>
      </div>

      {/* Zelle Modal */}
      <div
        className="modal fade"
        id="zelle-info-modal-meley"
        tabIndex="-1"
        aria-labelledby="zelleInfoModalTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-center" id="zelleInfoModalTitle">
                Use Zelle to save transaction fee!
              </h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <p>
                Recipient Name - <strong>Felsi Selam</strong>
              </p>
              <p>
                Send by e-mail - <strong>EriTigPeace@gmail.com</strong>
              </p>
              <hr className="my-4" />
              <p>Memo - Item Name and your shipping address </p>
              Example - <strong>Meley Flag. 123 Main St. Apt 10B. DC 20003 </strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeleyFlag;
